import { ApolloClient, InMemoryCache } from '@apollo/client';

const createShopifyClient = () => {
  const uri = 'https://88u3zfcw11.execute-api.us-east-1.amazonaws.com/dev/shopify';
  const client = new ApolloClient({
    uri,
    cache: new InMemoryCache(),
  });
  return client;
};

export default createShopifyClient;
